module.exports = __webpack_public_path__ + "img/icon-transparencia.365d1f9e.png";